import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import type { StaticContext } from '@swf/core/types/StaticContext';
import { DepositWizard } from '@swf/first';

import FirstRoute from './FirstRoute';

const DepositRoute: React.FC<{
  staticContext: StaticContext;
}> = ({ staticContext }) => {
  const hasClientSession = useSelector(select.session.hasClientSession);

  return hasClientSession ? (
    <FirstRoute component={DepositWizard} staticContext={staticContext} noCache />
  ) : null;
};

export default DepositRoute;
